module.exports = __webpack_public_path__ + "img/fengtan.6575c814.png";